module.exports = __webpack_public_path__ + "static/media/arrow-bended.2377ecaf.svg";